"use strict";
const { isNil, isEmpty, isArray } = require('lodash');
const missingRequiredParams = (message, requiredFields) => requiredFields.filter((prop) => (isArray(prop) ? prop.every((i) => isNil(message[i])) : isNil(message[prop])));
/**
 *
 * @param {*} param0
 * @param {string} topic
 * @param {string[]} requiredParams
 * @param {*} logger
 * @returns {*}
 */
const parseAndValidateMessage = ({ value }, topic, requiredParams = [], logger = console) => {
    try {
        const parsedMessage = JSON.parse(value.toString());
        const missingParams = missingRequiredParams(parsedMessage, requiredParams);
        if (!isEmpty(missingParams)) {
            logger.error('invalid kafka message: missing parameters', {}, {}, { topic, parsedMessage, missingParams: Object.values(missingParams).join(', ') });
            return null;
        }
        return parsedMessage;
    }
    catch (err) {
        logger.error('invalid kafka message: cannot parse message', {}, err, { topic, value });
        return null;
    }
};
module.exports = {
    parseAndValidateMessage,
};
//# sourceMappingURL=index.js.map